"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTemplateRequiredInVariantSuggestionRequest = instanceOfTemplateRequiredInVariantSuggestionRequest;
exports.TemplateRequiredInVariantSuggestionRequestFromJSON = TemplateRequiredInVariantSuggestionRequestFromJSON;
exports.TemplateRequiredInVariantSuggestionRequestFromJSONTyped = TemplateRequiredInVariantSuggestionRequestFromJSONTyped;
exports.TemplateRequiredInVariantSuggestionRequestToJSON = TemplateRequiredInVariantSuggestionRequestToJSON;
exports.TemplateRequiredInVariantSuggestionRequestToJSONTyped = TemplateRequiredInVariantSuggestionRequestToJSONTyped;
const zoneLocationsEnum_1 = require("./zoneLocationsEnum");
/**
 * Check if a given object implements the TemplateRequiredInVariantSuggestionRequest interface.
 */
function instanceOfTemplateRequiredInVariantSuggestionRequest(value) {
    if (!('template' in value) || value['template'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    return true;
}
function TemplateRequiredInVariantSuggestionRequestFromJSON(json) {
    return TemplateRequiredInVariantSuggestionRequestFromJSONTyped(json, false);
}
function TemplateRequiredInVariantSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'template': json['template'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'scryfallQuery': json['scryfallQuery'] == null ? undefined : json['scryfallQuery'],
        'zoneLocations': (json['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumFromJSON)),
        'battlefieldCardState': json['battlefieldCardState'] == null ? undefined : json['battlefieldCardState'],
        'exileCardState': json['exileCardState'] == null ? undefined : json['exileCardState'],
        'libraryCardState': json['libraryCardState'] == null ? undefined : json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'] == null ? undefined : json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'] == null ? undefined : json['mustBeCommander'],
    };
}
function TemplateRequiredInVariantSuggestionRequestToJSON(json) {
    return TemplateRequiredInVariantSuggestionRequestToJSONTyped(json, false);
}
function TemplateRequiredInVariantSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'template': value['template'],
        'quantity': value['quantity'],
        'scryfallQuery': value['scryfallQuery'],
        'zoneLocations': (value['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumToJSON)),
        'battlefieldCardState': value['battlefieldCardState'],
        'exileCardState': value['exileCardState'],
        'libraryCardState': value['libraryCardState'],
        'graveyardCardState': value['graveyardCardState'],
        'mustBeCommander': value['mustBeCommander'],
    };
}
//# sourceMappingURL=templateRequiredInVariantSuggestionRequest.js.map